import { render, staticRenderFns } from "./activityStatistics.vue?vue&type=template&id=2281c942&scoped=true&"
import script from "./activityStatistics.vue?vue&type=script&lang=js&"
export * from "./activityStatistics.vue?vue&type=script&lang=js&"
import style0 from "./activityStatistics.vue?vue&type=style&index=0&id=2281c942&prod&lang=less&scoped=true&"
import style1 from "./activityStatistics.vue?vue&type=style&index=1&id=2281c942&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2281c942",
  null
  
)

export default component.exports